import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close, NotesOutlined } from "@mui/icons-material";
import { radius, tokens } from "../theme/theme";

/**
 * The free-text "додаткова інформація" of one listing.
 *
 * Was a raw Modal pinned to a fixed 500x500 box with `overflow-y: scroll`, so
 * a one-line note got a scrollbar and a half-empty window, and there was no
 * close button — only clicking the backdrop. Now it sizes to its content and
 * scrolls only when it has to.
 */
const BuildingInfo = ({ infoText, openInfo, handleCloseInfo }) => {
  return (
    <Dialog
      open={openInfo}
      onClose={handleCloseInfo}
      fullWidth
      maxWidth="sm"
      PaperProps={{ sx: { borderRadius: radius.lg } }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1.5,
          borderBottom: "1px solid " + tokens.line,
          py: 2,
        }}
      >
        <NotesOutlined sx={{ color: tokens.blue600 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Додаткова інформація
        </Typography>
        <IconButton onClick={handleCloseInfo} aria-label="Закрити">
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 3, maxHeight: "60vh", overflowY: "auto" }}>
          <Typography
            variant="body1"
            sx={{
              // Realtors paste multi-line notes; without this they arrive as
              // one run-on paragraph.
              whiteSpace: "pre-wrap",
              color: infoText ? tokens.ink : tokens.ink400,
            }}
          >
            {infoText}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default BuildingInfo;

BuildingInfo.defaultProps = {
  infoText: "Немає додаткових даних",
};
